'use client';

import type { ReactNode } from 'react';
import { DialogTrigger as RACDialogTrigger } from 'react-aria-components';

export interface DialogRootProps {
  /** The dialog trigger with its associated dialog. Provide the trigger as the first child, and the dialog as the second child. */
  children: ReactNode;
  /** Whether the dialog is open (controlled). */
  isOpen?: boolean;
  /** Whether the dialog is open by default (uncontrolled). */
  defaultOpen?: boolean;
  /** Handler that is called when the dialog's open state changes. */
  onOpenChange?: (isOpen: boolean) => void;
}

/**
 * Encapsulates a dialog trigger and its associated dialog.
 * The trigger can be any Cimpress UI button, and the dialog will be displayed when the trigger is activated.
 */
export function DialogRoot(props: DialogRootProps) {
  return <RACDialogTrigger {...props} />;
}

DialogRoot.displayName = 'DialogRoot';
